import { z } from "zod";
import {
  STYLE_TRANSFER_INIT_IMAGE_INFLUENCE,
  STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_BLACK_AND_WHITE,
} from "../../../Board/Workspaces/CreateWorkspace/Tools/StyleTransferView/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

const zStyleTransferSettings = z.object({
  prompt: z.string().default(""),
  styleTransferBaseImageUuid: z.string().nullable().default(null),
  num_generations: z.number().default(4),
  colors_strength: z.number().default(0.5),
  structure_strength: z.number().default(0.5),
  creativity: z.number().default(0.5),
  init_image_color_influence: z
    .enum(STYLE_TRANSFER_INIT_IMAGE_INFLUENCE)
    .default(STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_BLACK_AND_WHITE),
});

export const styleTransferSettingsStorage = settingsStorageFactory(
  "style-transfer-settings",
  2,
  zStyleTransferSettings,
);
